import React, { createContext, useReducer } from "react";

const Reducer = (state, action) => {
    return state;
}
const initialState = {
    BasicInformation: {
        completed: false
      },
      ApplicationFee: {
        completed: false
      },
      Roster: {
        complete: false
      },
      TeamLogo: {
        completed: false
      },
      VideoAudition: {
        completed: false
    }
};

const Store = ({ children }) => {
    const [state, dispatch] = useReducer(Reducer, initialState);
    return (
        <Context.Provider value={[state, dispatch]}>
            {children}
        </Context.Provider>
    )
};

export const Context = createContext(initialState);
export default Store;